import { Days, IWorkingHoursItem } from '../shared';

export enum AvailabilityOverrideTypeEnum {
  ADD = 'ADD',
}

export interface IAvailabilityOverride {
  _id?: string;
  businessId: string;
  providingClientId: string;
  type: AvailabilityOverrideTypeEnum;
  startDate: string;
  endDate: string;
  daysOfWeek?: Days[];
  hours: IWorkingHoursItem[];
  branchId?: string;
  label?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type IAvailabilityOverrideInput = Omit<IAvailabilityOverride, '_id' | 'businessId' | 'createdAt' | 'updatedAt'>;
